import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../common/types';
import { ConfirmDialog } from '../../common/views/modals/confirmDialog/ConfirmDialog';
import { publicCoverMessages } from './publicCoverMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the cover editor; each part uses its own slice of it */
import styles from './PublicCoverMaker.module.scss';
import { withBrandWord } from '../../music24/components/primitives/BrandWord';

interface ContinueDialogProps {
  isOpen: boolean;
  /** The address that got the link to the design; null when the link goes later. */
  sentTo: string | null;
  onSignUp: () => void;
  onStay: () => void;
}

/**
 * After the download of the public tool (design cover-editor g4): the upsell after the first
 * value. "Continue in Music24" opens the sign-up with the email filled in; the design goes with
 * the visitor and opens in the editor of a song.
 */
const ContinueDialogComponent: React.FC<ContinueDialogProps> = ({ isOpen, sentTo, onSignUp, onStay }) => {
  const intl = useIntl();
  return (
    <ConfirmDialog
      isOpen={isOpen}
      tone="neutral"
      title={intl.formatMessage(publicCoverMessages.doneTitle)}
      description={
        sentTo === null
          ? intl.formatMessage(publicCoverMessages.doneLater)
          : intl.formatMessage(publicCoverMessages.doneSent, { email: sentTo })
      }
      confirmLabel={intl.formatMessage(publicCoverMessages.doneConfirm)}
      cancelLabel={intl.formatMessage(publicCoverMessages.doneStay)}
      onConfirm={onSignUp}
      onCancel={onStay}
    >
      <ol className={styles.steps}>
        <li>{intl.formatMessage(publicCoverMessages.doneStepCarry)}</li>
        <li>{withBrandWord(intl.formatMessage(publicCoverMessages.doneStepUse))}</li>
        <li>{intl.formatMessage(publicCoverMessages.doneStepPaid)}</li>
      </ol>
      <p className={styles.dialogHint}>{intl.formatMessage(publicCoverMessages.doneHint)}</p>
    </ConfirmDialog>
  );
};

export const ContinueDialog = TypedMemo(ContinueDialogComponent);
